import { RaceToTheRingPage } from './index'

import { RouteFactory } from './../../shared/router/Route.factory'
import { RequiresAuthGuard } from './../../shared/router/guards'

export default [
  RouteFactory.create(RaceToTheRingPage, '/race-to-the-ring', [new RequiresAuthGuard(true)], {
    name: 'Race to the Ring',
  }),
]
